import { API } from "../axios/API";

export const registrosService = {
  create,
  getRegistros,
  findRegistros
};

async function create (data){
  try {
    const response = await API.post("/registros", data); 
   
    return response.data;
  }
  catch (err) {
    return err.message;
  }
}

async function getRegistros (){
  try {
    const response = await API.get("/registros"); 
   
    return response.data;
  }
  catch (err) {
    return err.message;
  }
}

async function findRegistros (data){
  try {
    const response = await API.post("/registros/find", data); 
   
    return response.data;
  }
  catch (err) {
    return err.message;
  }
}
